import { render } from "./Access.vue?vue&type=template&id=71796486&scoped=true&lang=pug"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=71796486&lang=scss&scoped=true"
import "./Access.vue?vue&type=style&index=1&id=71796486&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71796486"]])

export default __exports__